import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    {
      question: 'WARP VPN이 무엇인가요?',
      answer: 'Cloudflare WARP는 인터넷 연결을 보호하고 속도를 향상시키는 VPN 서비스입니다. 신세계 그룹에서는 원격근무 시 안전한 회사 네트워크 접속을 위해 사용합니다.'
    },
    {
      question: '설치 후 인터넷이 연결되지 않아요.',
      answer: '네트워크 설정을 확인하고 WARP 애플리케이션에서 연결 상태를 점검해보세요. 문제가 지속될 경우 IT 지원팀에 문의하시기 바랍니다.'
    },
    {
      question: '모바일에서도 사용할 수 있나요?',
      answer: '네, iOS와 Android 모두 지원합니다. 각각 App Store와 Google Play Store에서 "1.1.1.1" 앱을 다운로드하여 사용하실 수 있습니다.'
    },
    {
      question: 'VPN 연결 시 속도가 느려져요.',
      answer: 'VPN 특성상 약간의 속도 저하가 있을 수 있습니다. 가장 가까운 서버로 연결되도록 설정을 확인하고, 지속적인 문제 시 IT 지원팀에 문의하세요.'
    },
    {
      question: '회사 외부에서만 사용해야 하나요?',
      answer: '원격근무 시에만 사용하시면 됩니다. 회사 내부 네트워크에서는 직접 연결을 사용하시고, 외부에서 회사 시스템 접속 시에만 WARP를 활성화하세요.'
    },
    {
      question: '비밀번호를 잊어버렸어요.',
      answer: 'WARP 계정 비밀번호는 IT 관리자에게 문의하시거나, 회사 계정 관리 시스템을 통해 재설정하실 수 있습니다.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            자주 묻는 질문 (FAQ)
          </h2>
          <p className="text-lg text-gray-600">
            WARP VPN 사용 중 자주 발생하는 질문들을 정리했습니다.
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div key={index} className="border border-gray-200 rounded-lg">
              <button
                className="w-full px-6 py-4 text-left focus:outline-none focus:ring-2 focus:ring-shinsegae-blue rounded-lg"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-medium text-gray-900">
                    {item.question}
                  </h3>
                  <span className="text-2xl text-gray-400">
                    {openIndex === index ? '−' : '+'}
                  </span>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-gray-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-gray-600">
            추가 문의사항이 있으시면 아래 문의처로 연락해주세요.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
